import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { IonContent } from '@ionic/react';

import { screen } from '$fcomponents/hoc';
// import OptionModel from '$gbusiness/models/option';

// import { ROUTES } from '$business/enums';
import { IonPageWrapper } from './styles';
import OrderStoreScreen from './orderStoreScreen';
import DateFilterModel from '$fbusiness/models/dateFilter';
import { ORDERS } from '$fbusiness/enums/columns';
import { defaultOrderColumns } from '$fscreens/accountScreen/historyScreen/ordersTable';

interface OrderScreenProps {
  history;
  currentState;
  dateFilter: DateFilterModel;
  columns;
  match;
}

// const TABS: Array<OptionModel> = [
//   { label: 'SCREEN.ORDERS.TABS.OVERVIEW', value: '' },
//   { label: 'SCREEN.ORDERS.TABS.STORE', value: 'store' },
//   { label: 'SCREEN.ORDERS.TABS.DEPARTMENT', value: 'departments' },
// ];

const OrderScreen: React.FC<OrderScreenProps> = React.memo(
  ({ history, match, dateFilter, columns, currentState }) => {
    // const {
    //   params: { tabIndex },
    // } = match;
    // const [currentTabIndex, setCurrentTabIndex] = useState(parseInt(tabIndex));
    // const handleRouteChange = index => {
    //   setCurrentTabIndex(index);
    //   history.replace(PATH.ORDER + '/' + index || '');
    // };
    // let component;
    // switch (currentTabIndex) {
    //   case 2:
    //     component = <OrderStoreScreen history={history} />;
    //     break;
    //   default:
    //     component = <OrderStoreScreen history={history} />;
    //     break;
    // }

    const orderColumns = columns ? columns[ORDERS] || defaultOrderColumns(currentState.settings) : [];

    const component = (
      <OrderStoreScreen
        orderColumns={orderColumns}
        dateFilter={dateFilter}
        currentState={currentState}
        history={history}
      />
    );

    return (
      <IonPageWrapper>
        {/* <ItemsHeader TABS={TABS} index={currentTabIndex} onChangeIndex={handleRouteChange} /> */}
        <IonContent>{component}</IonContent>
      </IonPageWrapper>
    );
  },
  (pp, np) => _.isEqual(pp.columns, np.columns),
);

const mapStateToProps = (state) => ({
  factory: state.factory.factory,
  invoice: state.invoice.invoice,
  columns: state.localStorage.columns,
  resetOnRoute: true,
});

const mapDispatchToProps = {};

const connected = connect(mapStateToProps, mapDispatchToProps);

export default connected(screen(OrderScreen));
